import axios from 'axios';

// Si no hay REACT_APP_API_URL configurado, usar el proxy (solo funciona en desarrollo)
// En producción, configurar REACT_APP_API_URL con la URL completa del backend
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Interceptor para manejar errores de conexión
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ECONNREFUSED' || error.message.includes('Network Error')) {
      console.error('❌ Error de conexión con el backend. Verifica que el servidor esté corriendo en', API_URL);
      error.response = {
        data: {
          success: false,
          message: 'No se puede conectar con el servidor. Verifica que el backend esté corriendo en el puerto 5001.'
        }
      };
    }
    return Promise.reject(error);
  }
);

export default api;
